import { css } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const cardStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '250px',
  background: '#D8D8D8',
  borderRadius: '3px',
  overflow: 'hidden',
  fontFamily: fonts.proxima,
})

export const cardMediaStyles = css({
  width: 'auto',
  height: 'auto',
  maxWidth: '100%',
  maxHeight: '100%',
})

export const cardTitleStyles = css({
  marginLeft: '10px',
  marginRight: '10px',
  display: 'flex',
  alignItems: 'center',
  width: 'calc(100% - 20px)',
  fontFamily: fonts.proxima,
  fontWeight: 600,
  fontSize: '14px',
  color: colors.n1.base,
})

export const cardSubtitleStyles = css({
  width: 'calc(100% - 20px)',
  fontSize: '13px',
  fontWeight: 500,
  fontFamily: fonts.proxima,
  color: colors.n4.base,
})

export const cardGenericStyles = css({
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  padding: '10px',
})

export const cardDividerStyles = css({
  width: '100%',
  height: '1px',
  background: colors.n7.base,
})

export const cardIconStyles = css({
  '.kuiper-icon-wrapper': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
})

export const cardLineItemStyles = css({
  width: 'calc(100% - 20px)',
  height: '30px',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  fontSize: '12px',
})
